/**
=========================================================
* INTELLIV Panou de Control React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// INTELLIV Panou de Control React components
import SoftBox from "components/SoftBox";

// INTELLIV Panou de Control React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import TimelineList from "examples/Timeline/TimelineList";
import TimelineItem from "examples/Timeline/TimelineItem";

import { useState, useEffect } from "react";
import FaqCollapse from "layouts/pages/pricing-page/components/FaqCollapse";
import Modal from "react-modal";
// Data
import timelineData from "layouts/pages/projects/timeline/data/timelineData";

import axios from "axios";
import { Navigate } from "react-router-dom";
import SoftTypography from "components/SoftTypography";

import { Popconfirm, Image } from "antd";

import SoftEditor from "components/SoftEditor";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import Swal from "sweetalert2";
import { token } from "stylis";
import Upload from "antd/es/upload/Upload";
import IconClose from "examples/Icons/CloseButton";
import IconDownload from "examples/Icons/DownloadButton";
import IconDelete from "examples/Icons/DeleteButton";
import IconPreview from "examples/Icons/PreviewButton";

//let testJson = require("./test.json");
const api_url = process.env.REACT_APP_API_URL;
const path = "C:\\Users\\Rara\\Desktop\\PDF-URI TLRV";
Modal.setAppElement("#root");

/*
axios
  .get(api_url + "all")
  .then((response) => {
    var message = response.data.message;
    var obj = JSON.parse(message);
    console.log(obj);
    data = obj;
  })
  .catch(function (error) {
    console.log(error);
  });

axios
  .get(api_url + "names")
  .then((response) => {
    var message = response.data.message;
    var obj = JSON.parse(message);
    names = obj;
  })
  .catch(function (error) {
    console.log(error);
  });
  */

const dummyRequest = ({ file, onSuccess }) => {
  setTimeout(() => {
    onSuccess("ok");
  }, 0);
};

const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
  });
//faq collapse dictionary

function TimelineTlrv() {
  const [loading, setLoading] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [faqTable, setFaqTable] = useState({});
  const [data, setData] = useState([]);
  const [names, setNames] = useState([]);
  

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [uploadedPdf, setUploadedPdf] = useState(null);
  const [filelist, setFilelist] = useState([]); //for images
  const [refreshList, setRefreshList] = useState(false);


  const [edit, setEdit] = useState(true);

  const switchFaqTable = (pdfName) => {
    setFaqTable(prevState => ({
      ...prevState,
      [pdfName]: !prevState[pdfName]
    }));
  };
  

  const handleEdit =
    (
      title,
      pdf,
    ) =>
    () => {
      setModalTitle(title);
      setUploadedPdf(pdf);
      setModalIsOpen(true);
    };

  const handleSave = () => {
    setModalLoading(true);
    console.log("save");
    
    var url = api_url + "/tlrv/add";
      
    const formData = new FormData();
    formData.append('pdf', uploadedPdf);
    
    var jwToken = localStorage.getItem("token");
      
    const headers = {
      Authorization: "Bearer " + jwToken,

    };
    
    axios.post(url, formData, { headers: headers })
      .then((response) => {
        console.log(response.data.success);
        setModalIsOpen(false);
        if (!response.data.success) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "PDF - ul a fost deja adaugat cu acest nume!",
          });
        } else {
        Swal.fire({
          icon: "success",
          title: "Succes!",
          text: "PDF - ul a fost adaugat cu succes!",
        });
      }
        setModalLoading(false);
        setRefreshList(prev => !prev);
      })
      .catch((error) => {
        console.error(error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Ceva nu a mers bine!",
        });
        setModalLoading(false);
      });
  };

  useEffect(() => {
    setLoading(true);
    axios.get(`${api_url}/tlrv/list-pdfs`)
      .then((response) => {
        setData(response.data.pdf_files);
        setLoading(false);
      })
      .catch(error => {
        console.error("There was an error fetching the PDFs:", error);
        setLoading(false);
      });
  }, [refreshList]);

  const handleDelete = (pdfName) => () => {
    const url = `${api_url}/tlrv/delete-pdf/${encodeURIComponent(pdfName)}`;
    const jwToken = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${jwToken}`,
    };
  
    axios.delete(url, { headers })
      .then(response => {
        console.log(response.data);
          setRefreshList(prev => !prev);
        Swal.fire({
          icon: "success",
          title: "Succes!",
          text: "PDF-ul a fost șters cu succes!",
        });
      })
      .catch(error => {
        console.error(error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Ceva nu a mers bine!",
        });
      });
  };

  const handleDownload = (pdfName) => {
    const url = `${api_url}/tlrv/get-pdf/${encodeURIComponent(pdfName)}`;
    const jwToken = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${jwToken}`,
    };
  
    axios.get(url, { headers, responseType: 'json' }) // Așteptăm un răspuns de tip JSON
      .then(response => {
        const base64Pdf = response.data.pdf;
  
        const byteCharacters = atob(base64Pdf);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const pdfBlob = new Blob([byteArray], { type: 'application/pdf' });
  
        const blobUrl = URL.createObjectURL(pdfBlob);
  
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = pdfName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(blobUrl);
      })
      .catch(error => {
        console.error('Error while trying to download PDF:', error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Nu am putut descărca PDF-ul.",
        });
      });
  };
  

  const handlePreview = (pdfName) => {
    const url = `${api_url}/tlrv/get-pdf/${encodeURIComponent(pdfName)}`;
    const jwToken = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${jwToken}`,
    };
  
    axios.get(url, { headers, responseType: 'json' })
      .then(response => {
        const base64Pdf = response.data.pdf;
  
        const byteCharacters = atob(base64Pdf);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const pdfBlob = new Blob([byteArray], { type: 'application/pdf' });
        const blobUrl = URL.createObjectURL(pdfBlob);
  
        // Deschide URL-ul blob într-o nouă filă pentru previzualizare
        window.open(blobUrl, '_blank');
      })
      .catch(error => {
        console.error('Error while trying to preview PDF:', error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Nu am putut previzualiza PDF-ul.",
        });
      });
  };

  const namesElement = data && data.map((pdf, index) => {
    const pdfName = pdf["name"];
    return (
      <div>
        <FaqCollapse
          title={pdfName}
          key={pdfName + index}
          open={faqTable[pdfName]}
          onClick={() => switchFaqTable(pdfName)}
        >
          <div style={{ display: "flex", flexDirection: "row", gap: "60px", marginBottom: "15px" }}>
            <SoftTypography
                className="cursor-pointer"
                variant="h6"
                fontWeight="bold"
                color="text"
                onClick={() => handlePreview(pdf["name"])}
              >
              <IconPreview/>
            </SoftTypography>
              <SoftTypography
                  className="cursor-pointer"
                  variant="h6"
                  fontWeight="bold"
                  color="text"
                  onClick={() => handleDownload(pdf["name"])}
              >
                <IconDownload/>
              </SoftTypography>
            <Popconfirm
              title="Sigur doriți să ștergeți acest PDF?"
              onConfirm={handleDelete(pdfName)}
              okText="Da"
              cancelText="Nu"
            >
              <SoftTypography
                className="cursor-pointer"
                variant="h6"
                fontWeight="bold"
                color="text"
              >
                <IconDelete/>
              </SoftTypography>
            </Popconfirm>
          </div>
        </FaqCollapse>
      </div>
    );
  });

    return (
      <>
        <Modal
          shouldCloseOnOverlayClick={false}
          isOpen={modalIsOpen}
          onRequestClose={() => setModalIsOpen(false)}
          contentLabel="Editare intrare"
          style={{
            overlay: {
              backgroundColor: "rgba(0, 0, 0, 0.75)",
              zIndex: 10000, // Set the z-index here
            },
            content: {
              color: "lightsteelblue",
            },
          }}
        >
          <SoftBox p={3}>
            <div className="close-button">
          <SoftButton
                  variant="contained"
                  color="secondary"
                  onClick={() => {
                    setModalIsOpen(false);
                    setUploadedPdf(null);
                    // set modal content to default values
                  }}
                >
                <IconClose/>
            </SoftButton>
            </div>
            <SoftTypography variant="h3" component="h3">
              <div style={{ textAlign: "center"}}>{modalTitle}</div>
            </SoftTypography>
            <SoftBox my={5}>
              <SoftBox my={5}>
                <SoftTypography variant="h4" component="h4">
                  <div>PDF-uri</div>
                </SoftTypography>
                <div className="editImagesSection">
                {uploadedPdf && (
                    <>
                      <div
                        style={{
                          backgroundColor: "lightsteelblue",
                          padding: "10px",
                          marginBottom: "10px",
                          width: "100%",
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                            <div>PDF Încărcat</div>
                        {/* arrows to move up and down in order,if first element NO up arrow, if last element NO down arrow */}
                        <div
                          className="editImageContainer-wrapper-image"
                          style={{
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >
                          <button
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              setUploadedPdf(null);
                            }}
                          >
                            ✖ Șterge
                          </button>
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                        }}
                      >
                        <div className="editImageContainer">
                          <div className="editImageOverlay"></div>
                          {/* <div
                            className="editImageDelete"
                            onClick={() => {
                              var temp = modalImages;
                              var tempLegends = modalLegends;
                              temp.splice(index, 1);
                              tempLegends.splice(index, 1);
                              setModalImages([]);
                              setModalLegends([]);
                              setTimeout(() => {
                                setModalImages(temp);
                                setModalLegends(tempLegends);
                              }, 200);
                            }}
                          >
                            ✖ Șterge
                          </div> */}
                          {/* <div className="downloadImage">
                            <a
                              href={image.match(/src="([^"]*)/)[1]}
                              download="image"
                            >
                              ⇩ Descarcă
                            </a>
                          </div> */}
                        </div>
                        <div
                          className="editImageText"
                          style={{
                            marginRight: "20px",
                            width: "50%",
                          }}
                        >
                          {/* <SoftInput
                          placeholder="legendă"
                          defaultValue={modalLegends[index]}
                          onChange={(e) => {
                            var temp = modalLegends;
                            var tempVal = e.target.value;
                            if (tempVal == "" || tempVal == null) tempVal = " ";
                            temp[index] = tempVal;
                            console.log(temp);

                            setModalLegends(temp);
                            // setModalLegends([]); //?
                            // setTimeout(() => {
                            //   setModalLegends(temp);
                            // }, 200);
                          }}
                        /> */}
                          {/* <SoftEditor
                            modules={modules}
                            preserveWhitespace={true}
                            value={modalLegends[index]}
                            onChange={(value) => {
                              var temp = modalLegends;
                              var tempVal = value;
                              if (tempVal == "" || tempVal == null)
                                tempVal = " ";
                              temp[index] = tempVal;
                              console.log(temp);

                              setModalLegends(temp);
                            }}
                          /> */}
                        </div>
                      </div>
                    </>
                  )}
                </div>
                <Upload
                    listType="picture-card"
                    fileList={filelist}
                    accept="application/pdf"
                    customRequest={dummyRequest}
                    onChange={(info) => {
                      const file = info.file.originFileObj;
                      setUploadedPdf(file)
                      console.log(file);
                    }}
                  >
                  {!uploadedPdf && <div>+ Adaugă PDF</div>}
                </Upload>
              </SoftBox>
            </SoftBox>
            <Grid container spacing={3} mb={3} justifyContent={"center"}>
              <Grid item>
                {modalLoading ? (
                  <SoftButton variant="contained" color="info">
                    Se încarcă...
                  </SoftButton>
                ) : (
                  <SoftButton
                    variant="contained"
                    color="info"
                   onClick={handleSave}
                  >
                    Salvează
                  </SoftButton>
                )}
              </Grid>
              <Grid item>
                <SoftButton
                  variant="contained"
                  color="secondary"
                  onClick={() => {
                    setModalIsOpen(false);
                    setUploadedPdf(null);
                    // set modal content to default values
                  }}
                >
                  Anulează
                </SoftButton>
              </Grid>
            </Grid>
          </SoftBox>
        </Modal>
        {localStorage.getItem("token") == null ? (
          <Navigate to="/authentication/login" />
        ) : (
          <DashboardLayout>
            <DashboardNavbar />
            {/** menu with letters from a-z, horizontall */}
  
            {loading ? (
              <SoftBox my={3}>
                <SoftTypography variant="h6" component="h6">
                  <div style={{ textAlign: "center" }}>Se încarcă...</div>
                </SoftTypography>
              </SoftBox>
            ) : (
              <SoftBox my={3}>
                <SoftBox mb={3}>
                  <SoftButton
                    variant="contained"
                    color="info"
                    onClick={handleEdit("Adaugare PDF",null)}
                  >
                    + Adaugă PDF
                  </SoftButton>
                </SoftBox>
                <TimelineList title="Texte Fundamentale ale Literaturii Romane Vechi">
                  {namesElement}
                </TimelineList>
              </SoftBox>
            )}
            <Footer />
          </DashboardLayout>
        )}
      </>
    );
}

export default TimelineTlrv;
